module.exports = __webpack_public_path__ + "static/media/img_sec_one.dc3646b7.png";